export default __webpack_public_path__ + "static/media/d0825b53d5c9ab2d6cb87cf1757406321581616868738.3c8ff8fd.webp";